module.exports = __webpack_public_path__ + "img/workingTimeRecords.015f0ef1.png";